import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(accordionAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var baseStyle = definePartsStyle({
    container: {
        bg: 'neutrals.white',
        boxShadow: 'shadow-low',
        border: 'none',
        borderRadius: 'lg',
        width: '343px',
        margin: 'auto'
    },
    button: {
        color: 'neutrals.900',
        fontWeight: '500',
        borderRadius: 'lg',
        p: '16px 24px 16px 16px',
        gap: '16px',
        _hover: {
            bg: 'neutrals.white'
        }
    },
    icon: {
        width: '16px',
        height: '16px',
        color: 'neutrals.900',
    },
    panel: {
        color: 'neutrals.900',
        fontSize: 'md',
        fontWeight: '400',
        p: '8px 24px 16px 16px'
    }
});
var accordionTheme = defineMultiStyleConfig({ baseStyle: baseStyle });

export { accordionTheme };
//# sourceMappingURL=accordion.js.map
